import { AlertGroupName, AlertRuleName, AlertSeverity } from '../enums'

export enum AlertSensor {
  DEVICE = 'device',
  RUUVITAG = 'ruuvitag',
  VALVE = 'valve'
}

export type AlertGroup = {
  name: AlertGroupName
  alerts: AlertRule[]
}

export type AlertRule = {
  name: AlertRuleName
  enabled: boolean
  sensor?: AlertSensor
  severity?: AlertSeverity
  variables: AlertVariables
}

export type AlertVariables = Record<string, AlertParamValues> & {
  param1: AlertParamValues
  param2?: AlertParamValues
  param3?: AlertParamValues
  metric?: AlertParamValues
  function?: AlertParamValues
  time?: AlertParamValues
}

export enum AlertRuleVariableType {
  FLOAT = 'float',
  SELECTION_AVG_OVER_TIME_MAX_OVER_TIME_MIN_OVER_TIME = 'selection(avg_over_time|max_over_time|min_over_time)'
}

export enum AlertRuleVariableUnit {
  PERCENTAGE = '%',
  STATUS = 'Status',
  RELATIVE_HUMIDITY = '%RH',
  DECIBEL_MILLIWATT = 'dBm',
  CELSIUS = '°C',
  VOLT = 'V',
  MILLIVOLT = 'mV',
  HECTOPASCAL = 'hPa',
  MINUTES = 'min'
}

export type AlertParamValues = {
  type: string
  value: number | string
  unit: string
  readonly?: boolean
}

export type AlertTemplate = {
  name: AlertGroupName
  defaults: Record<
    string,
    {
      enabled: boolean
      variables: AlertVariables
    }
  >
  rules: AlertTemplateRule[]
}

export type AlertTemplateRule = {
  alert: AlertRuleName
  expr: string
  labels: {
    severity: string
    sensor?: string
  }
  annotations: {
    summary: string
  }
}

export type AlertNotifications = {
  emailNotificationEnabled: boolean
  smsNotificationEnabled: boolean
  appNotificationEnabled: boolean
}
